(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pairs-well-with"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    // Initialize each pairs-well-with instance separately
    const pairsContainers = document.querySelectorAll('.pairs-well-with');
    
    pairsContainers.forEach(function(container) {
      const uniqueId = container.dataset.uniqueId;
      if (!uniqueId) return;
      
      // Get variant data for this specific instance
      const variantDataElement = container.querySelector('.pairs-variants-data');
      if (!variantDataElement) return;
      
      const variantData = JSON.parse(variantDataElement.textContent);
      const productImage = container.querySelector('.pairs-product-image');
      const priceElement = container.querySelector('.price-current');
      const compareAtPriceElement = container.querySelector('.price-compare');
      
      // Function to find variant based on selected options
      function findVariantByOptions(selectedOptions) {
        return variantData.variants.find(variant => {
          return selectedOptions.every((selectedValue, index) => {
            return variant.options[index] === selectedValue;
          });
        });
      }
      
      // Function to get currently selected options within this container
      function getSelectedOptions() {
        const selectedOptions = [];
        const optionGroups = container.querySelectorAll('.variant-group');
      
      optionGroups.forEach((group, index) => {
        const activeBtn = group.querySelector('.variant-btn.active');
        if (activeBtn) {
          selectedOptions[index] = activeBtn.dataset.value;
        }
      });
      
      return selectedOptions;
    }
    
    // Function to update product display
    function updateProductDisplay() {
      const selectedOptions = getSelectedOptions();
      const selectedVariant = findVariantByOptions(selectedOptions);
      
      // Update available color options based on selected size
      updateAvailableColors();
      
      if (selectedVariant) {
        // Update image - priorizar sleep_gallery, depois featured_image
        if (selectedVariant.sleep_gallery_image && productImage) {
          productImage.src = selectedVariant.sleep_gallery_image;
          productImage.alt = selectedVariant.title;
        } else if (selectedVariant.featured_image && productImage) {
          productImage.src = selectedVariant.featured_image;
          productImage.alt = selectedVariant.title;
        }
        
        // Update price
        if (priceElement) {
          const price = Math.floor(selectedVariant.price / 100);
          priceElement.textContent = '$' + price;
        }
        
        // Update compare at price
        if (compareAtPriceElement) {
          if (selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price) {
            const comparePrice = Math.floor(selectedVariant.compare_at_price / 100);
            compareAtPriceElement.textContent = '$' + comparePrice;
            compareAtPriceElement.style.display = 'inline';
          } else {
            compareAtPriceElement.style.display = 'none';
          }
        }
        
        console.log('Updated to variant:', selectedVariant.title, 'Sleep Gallery:', selectedVariant.sleep_gallery_image, 'Featured Image:', selectedVariant.featured_image_large || selectedVariant.featured_image);
      }
    }

    // Function to update available colors based on selected options (or independently)
    function updateAvailableColors() {
      const selectedOptions = getSelectedOptions();
      const colorButtons = container.querySelectorAll('.color-btn');
      
      // Get the index of size and color options
      const optionGroups = container.querySelectorAll('.variant-group');
      let sizeIndex = -1;
      let colorIndex = -1;
      
      optionGroups.forEach((group, index) => {
        const optionName = group.dataset.optionName.toLowerCase();
        if (optionName.includes('size')) {
          sizeIndex = index;
        } else if (optionName.includes('color') || optionName.includes('colour')) {
          colorIndex = index;
        }
      });
      
      // If no color options, skip this function
      if (colorIndex === -1) return;
      
      // Get available colors with stock info
      const availableColors = new Map();
      
      variantData.variants.forEach(variant => {
        const colorName = variant.options[colorIndex];
        
        // Check if this variant matches the selected non-color options
        let isValidVariant = true;
        
        selectedOptions.forEach((selectedValue, index) => {
          // Skip color index, we're checking all colors
          // Only validate non-color options
          if (index !== colorIndex && selectedValue && variant.options[index] !== selectedValue) {
            isValidVariant = false;
          }
        });
        
        // If there's no size option OR variant matches the size, include it
        if (isValidVariant) {
          const hasStock = variant.available && (
            variant.inventory_policy === 'continue' || 
            variant.inventory_quantity > 0
          );
          
          // Keep track of color availability - if any variant has stock, color is available
          if (!availableColors.has(colorName)) {
            availableColors.set(colorName, {
              hasStock: hasStock,
              inventory: variant.inventory_quantity,
              inventory_policy: variant.inventory_policy,
              variant: variant
            });
          } else if (hasStock && !availableColors.get(colorName).hasStock) {
            // Update if we found a variant with stock
            availableColors.set(colorName, {
              hasStock: hasStock,
              inventory: variant.inventory_quantity,
              inventory_policy: variant.inventory_policy,
              variant: variant
            });
          }
        }
      });
      
      // Show/hide/disable color buttons based on availability and stock
      colorButtons.forEach(button => {
        const colorValue = button.dataset.value;
        const colorInfo = availableColors.get(colorValue);
        
        if (colorInfo) {
          button.style.display = 'flex';
          
          if (colorInfo.hasStock) {
            // Color has stock - enable button
            button.disabled = false;
            button.classList.remove('out-of-stock');
            button.title = colorValue;
          } else {
            // Color exists but no stock - disable button
            button.disabled = true;
            button.classList.add('out-of-stock');
            button.title = colorValue + ' (Out of Stock)';
            
            // Remove active class if this color is out of stock
            if (button.classList.contains('active')) {
              button.classList.remove('active');
              // Select the first available color with stock
              const firstAvailableColor = container.querySelector('.color-btn:not(.out-of-stock):not([disabled])');
              if (firstAvailableColor) {
                firstAvailableColor.classList.add('active');
              }
            }
          }
        } else {
          // Color doesn't exist for the selected options
          button.style.display = 'none';
          button.disabled = true;
          if (button.classList.contains('active')) {
            button.classList.remove('active');
            const firstAvailableColor = container.querySelector('.color-btn[style*="display: flex"]:not([disabled])');
            if (firstAvailableColor) {
              firstAvailableColor.classList.add('active');
            }
          }
        }
      });
      
      const selectedSizeText = sizeIndex >= 0 && selectedOptions[sizeIndex] ? ' for ' + selectedOptions[sizeIndex] : '';
    }
    
      // Handle variant selection within this container
      const variantBtns = container.querySelectorAll('.variant-btn');

      variantBtns.forEach((btn) => {
        btn.addEventListener('click', function () {
          // Don't proceed if button is disabled
          if (this.disabled) return;
          
          // Remove active class from siblings
          const siblings = this.parentNode.querySelectorAll('.variant-btn');
          siblings.forEach((sibling) => sibling.classList.remove('active'));

          // Add active class to clicked button
          this.classList.add('active');
          
          // Update product display - esta é a parte principal!
          updateProductDisplay();
        });
      });

      // Handle quantity controls within this container
      const quantityInput = container.querySelector('.quantity-input');
      const minusBtn = container.querySelector('.quantity-btn.minus');
      const plusBtn = container.querySelector('.quantity-btn.plus');

    if (minusBtn) {
      minusBtn.addEventListener('click', function () {
        const currentValue = parseInt(quantityInput.value);
        if (currentValue > 1) {
          quantityInput.value = currentValue - 1;
        }
      });
    }

    if (plusBtn) {
      plusBtn.addEventListener('click', function () {
        const currentValue = parseInt(quantityInput.value);
        quantityInput.value = currentValue + 1;
      });
    }

      // Handle add to cart within this container
      const addToCartBtn = container.querySelector('.add-to-cart-btn');
      if (addToCartBtn) {
        addToCartBtn.addEventListener('click', function () {
          const selectedOptions = getSelectedOptions();
          const selectedVariant = findVariantByOptions(selectedOptions);
          const quantity = container.querySelector('.quantity-input').value;

          if (selectedVariant) {
            
            fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                id: selectedVariant.id,
                quantity: parseInt(quantity)
              })
            })
            .then(response => response.json())
            .then(data => {
              console.log('Success:', data);
              // Atualizar UI do carrinho
            })
            .catch((error) => {
              console.error('Error:', error);
            });
          }
        });
      }
      
      // Initialize display with default selection for this container
      updateProductDisplay();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
